import { useQuery } from '@tanstack/react-query'
import api from '../../config/axios-config'
import { featurebaseQueryKeys } from '../constants'

export const useGetJwtTokenQuery = (options) => {
  const getJwtToken = async () => {
    const config = {
      method: 'get'
    }

    const { data } = await api('/api/v2/featurebase/generate-token', config)
    return data
  }

  return useQuery({
    queryKey: [featurebaseQueryKeys.JWT_TOKEN],
    queryFn: getJwtToken,
    retry: 0,
    ...options
  })
}
